import { lt } from '@mews/framework';
import { Card, CardContent } from '@optimus-web/core';
import { CardHeader } from '../../../../../guestSummaryPanel';
import { ReservationsSegmentControl, ReservationsSegmentControlProps } from './components';

export type ReservationsOverviewProps = ReservationsSegmentControlProps;

export const ReservationsOverview = ({ reservations }: ReservationsOverviewProps) => (
    <Card>
        <CardContent padding="200">
            <CardHeader title={lt('AccountMergeGuestDetailReservations')} value={reservations.length} />
        </CardContent>
        <ReservationsSegmentControl reservations={reservations} />
    </Card>
);
